/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockContent } from '../../models/block-content';

export interface ApiMasterBlockContentGetActiveGet$Params {
}

export function apiMasterBlockContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterBlockContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterBlockContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockContent>>;
    })
  );
}

apiMasterBlockContentGetActiveGet.PATH = '/api/Master/BlockContent/GetActive';
